import { constants } from './../app-constants';
import { PaginacaoParamModel } from './../model/paginacao-param.model';
import { Component, OnInit, Output } from '@angular/core';
import { OrdemServicoService } from '../service/ordem-servico.service';
import { AtivoModel } from '../model';
import {NgxUiLoaderService} from "ngx-ui-loader";

@Component({
  selector: 'app-criar-osendereco',
  templateUrl: './criar-osendereco.component.html',
  styleUrls: ['./criar-osendereco.component.css']
})
export class CriarOSEnderecoComponent implements OnInit {
  paginacao: PaginacaoParamModel = new PaginacaoParamModel();
  numberPage = 1;

  enderecos: Array<any> = [];
  enderecosAtivo: Array<any> = [];

  enderecoSelecionado: any;
  ativo: any;
  display: Boolean = false;

  selecionarEndereco($event) {
    this.enderecoSelecionado = $event;
    localStorage.setItem(constants.enderecoSelecionadoKey, JSON.stringify(this.enderecoSelecionado));
  }

  constructor(private loadingBar: NgxUiLoaderService,
              private ordemServicoService: OrdemServicoService) { }

  ngOnInit() {
    this.ativo = JSON.parse(localStorage.getItem(constants.ativoKey));
    if (this.ativo === null ||
          this.ativo === undefined) {
      this.listarEnderecos(this.paginacao);
    } else {
      this.onSuccess(this.ativo.enderecos);
    }

  }

  public listarEnderecos(paginacao: PaginacaoParamModel) {
    this.loadingBar.start();
    this.ordemServicoService.listarEnderecos(paginacao)
    .subscribe(response => {
      this.numberPage++;
      this.onSuccess(response.enderecos);
    });
  }

  onSuccess(res) {
    this.loadingBar.stop();
    if (res) {
      res.forEach(endereco => {
        this.enderecos.push(endereco);
      });
    }
  }

  public onScroll() {
    this.paginacao.paginaAtual = this.numberPage;
    this.listarEnderecos(this.paginacao);
  }

}
